import { KMutableProperty11e8g1gb0ecb9j as KMutableProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { pipelineContextFor1bwb6ae3xig1h as pipelineContextFor } from './PipelineContext.mjs';
import { PhaseContent20yhla4zqpd2q as PhaseContent } from './PhaseContent.mjs';
import {
  Last_getInstance2oozbuk4fjpsn as Last_getInstance,
  After9djz11pmyzvq as After,
  Beforeyqm571m7tesc as Before,
} from './PipelinePhaseRelation.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  mutableListOf6oorvk2mtdmp as mutableListOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  equals2au1ep9vhcato as equals,
  anyToString3ho3k49fc56mj as anyToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { last1vo29oleiqj36 as last } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../Attributes.web.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from '../../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { InvalidPhaseExceptionxbo9a9gosqf3 as InvalidPhaseException } from './PipelinePhase.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _set_interceptors__wod97b($this, _set____db54di) {
  var tmp0 = $this.r4s_1;
  var tmp = KMutableProperty1();
  var tmp_0 = Pipeline$_get_interceptors_$ref_u6zl4e();
  // Inline function 'kotlinx.atomicfu.AtomicRef.setValue' call
  getPropertyCallableRef('interceptors', 1, tmp, tmp_0, Pipeline$_set_interceptors_$ref_13vc1m());
  tmp0.kotlinx$atomicfu$value = _set____db54di;
  return Unit_instance;
}
function _get_interceptors__h4min7($this) {
  var tmp0 = $this.r4s_1;
  var tmp = KMutableProperty1();
  var tmp_0 = Pipeline$_get_interceptors_$ref_u6zl4e();
  // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
  getPropertyCallableRef('interceptors', 1, tmp, tmp_0, Pipeline$_set_interceptors_$ref_13vc1m());
  return tmp0.kotlinx$atomicfu$value;
}
function createContext($this, context, subject, coroutineContext) {
  return pipelineContextFor(context, sharedInterceptorsList($this), subject, coroutineContext, $this.u4s());
}
function findPhase($this, phase) {
  var phasesList = $this.p4s_1;
  var inductionVariable = 0;
  var last = phasesList.q2();
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var current = phasesList.r2(index);
      if (current === phase) {
        var content = PhaseContent().h4s(phase, Last_getInstance());
        phasesList.j3(index, content);
        return content;
      }
      var tmp;
      if (current instanceof PhaseContent()) {
        tmp = current.b4s_1 === phase;
      } else {
        tmp = false;
      }
      if (tmp) {
        return current instanceof PhaseContent() ? current : THROW_CCE();
      }
    }
     while (inductionVariable < last);
  return null;
}
function findPhaseIndex($this, phase) {
  var phasesList = $this.p4s_1;
  var inductionVariable = 0;
  var last = phasesList.q2();
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var current = phasesList.r2(index);
      var tmp;
      if (current === phase) {
        tmp = true;
      } else {
        var tmp_0;
        if (current instanceof PhaseContent()) {
          tmp_0 = current.b4s_1 === phase;
        } else {
          tmp_0 = false;
        }
        tmp = tmp_0;
      }
      if (tmp) {
        return index;
      }
    }
     while (inductionVariable < last);
  return -1;
}
function hasPhase($this, phase) {
  var phasesList = $this.p4s_1;
  var inductionVariable = 0;
  var last = phasesList.q2();
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var current = phasesList.r2(index);
      var tmp;
      if (current === phase) {
        tmp = true;
      } else {
        var tmp_0;
        if (current instanceof PhaseContent()) {
          tmp_0 = current.b4s_1 === phase;
        } else {
          tmp_0 = false;
        }
        tmp = tmp_0;
      }
      if (tmp) {
        return true;
      }
    }
     while (inductionVariable < last);
  return false;
}
function cacheInterceptors($this) {
  var interceptorsQuantity = $this.q4s_1;
  if (interceptorsQuantity === 0) {
    notSharedInterceptorsList($this, emptyList());
    return emptyList();
  }
  var phases = $this.p4s_1;
  if (interceptorsQuantity === 1) {
    var inductionVariable = 0;
    var last = get_lastIndex(phases);
    if (inductionVariable <= last)
      $l$loop_0: do {
        var phaseIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = phases.r2(phaseIndex);
        var tmp0_elvis_lhs = tmp instanceof PhaseContent() ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var phaseContent = tmp_0;
        if (phaseContent.i4s())
          continue $l$loop_0;
        var interceptors = phaseContent.l4s();
        setInterceptorsListFromPhase($this, phaseContent);
        return interceptors;
      }
       while (!(phaseIndex === last));
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var destination = ArrayList().p2();
  var inductionVariable_0 = 0;
  var last_0 = get_lastIndex(phases);
  if (inductionVariable_0 <= last_0)
    $l$loop_1: do {
      var phaseIndex_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var tmp_1 = phases.r2(phaseIndex_0);
      var tmp1_elvis_lhs = tmp_1 instanceof PhaseContent() ? tmp_1 : null;
      var tmp_2;
      if (tmp1_elvis_lhs == null) {
        continue $l$loop_1;
      } else {
        tmp_2 = tmp1_elvis_lhs;
      }
      var phase = tmp_2;
      phase.k4s(destination);
    }
     while (!(phaseIndex_0 === last_0));
  notSharedInterceptorsList($this, destination);
  return destination;
}
function sharedInterceptorsList($this) {
  if (_get_interceptors__h4min7($this) == null) {
    cacheInterceptors($this);
  }
  $this.s4s_1 = true;
  return ensureNotNull(_get_interceptors__h4min7($this));
}
function resetInterceptorsList($this) {
  _set_interceptors__wod97b($this, null);
  $this.s4s_1 = false;
  $this.t4s_1 = null;
}
function notSharedInterceptorsList($this, list) {
  _set_interceptors__wod97b($this, list);
  $this.s4s_1 = false;
  $this.t4s_1 = null;
}
function setInterceptorsListFromPhase($this, phaseContent) {
  _set_interceptors__wod97b($this, phaseContent.l4s());
  $this.s4s_1 = false;
  $this.t4s_1 = phaseContent.b4s_1;
}
function tryAddToPhaseFastPath($this, phase, block) {
  var currentInterceptors = _get_interceptors__h4min7($this);
  if ($this.p4s_1.n1() || currentInterceptors == null) {
    return false;
  }
  var tmp;
  if ($this.s4s_1) {
    tmp = true;
  } else {
    tmp = !isInterface(currentInterceptors, KtMutableList());
  }
  if (tmp) {
    return false;
  }
  if (equals($this.t4s_1, phase)) {
    currentInterceptors.i2(block);
    return true;
  }
  if (equals(phase, last($this.p4s_1)) || findPhaseIndex($this, phase) === get_lastIndex($this.p4s_1)) {
    ensureNotNull(findPhase($this, phase)).j4s(block);
    currentInterceptors.i2(block);
    return true;
  }
  return false;
}
function Pipeline$_get_interceptors_$ref_u6zl4e() {
  return constructCallableReference((p0) => _get_interceptors__h4min7(p0), 1, 0, 206);
}
function Pipeline$_set_interceptors_$ref_13vc1m() {
  return constructCallableReference((p0, p1) => {
    _set_interceptors__wod97b(p0, p1);
    return Unit_instance;
  }, 2, 0, 207);
}
var PipelineClass;
function Pipeline() {
  if (PipelineClass === VOID) {
    class $ {
      constructor(phases) {
        this.n4s_1 = AttributesJsFn(true);
        this.o4s_1 = false;
        this.p4s_1 = mutableListOf(phases.slice());
        this.q4s_1 = 0;
        this.r4s_1 = atomic$ref$1(null);
        this.s4s_1 = false;
        this.t4s_1 = null;
      }
      u4s() {
        return this.o4s_1;
      }
      *v4s(context, subject, $completion) {
        // Inline function 'kotlin.js.getCoroutineContext' call
        var tmp$ret$0 = $completion.pc();
        return yield* createContext(this, context, subject, tmp$ret$0).a4s(subject, $completion);
      }
      x4s(reference, phase) {
        if (hasPhase(this, phase))
          return Unit_instance;
        var index = findPhaseIndex(this, reference);
        if (index === -1) {
          throw new (InvalidPhaseException())('Phase ' + reference.toString() + ' was not registered for this pipeline');
        }
        var lastRelatedPhaseIndex = index;
        var inductionVariable = index + 1 | 0;
        var last = get_lastIndex(this.p4s_1);
        if (inductionVariable <= last)
          $l$loop_0: do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = this.p4s_1.r2(i);
            var tmp0_safe_receiver = tmp instanceof PhaseContent() ? tmp : null;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c4s_1;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              break $l$loop_0;
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }
            var relation = tmp_0;
            var tmp2_safe_receiver = relation instanceof After() ? relation : null;
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.y4s_1;
            var tmp_1;
            if (tmp3_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp_1 = tmp3_elvis_lhs;
            }
            var relatedTo = tmp_1;
            lastRelatedPhaseIndex = equals(relatedTo, reference) ? i : lastRelatedPhaseIndex;
          }
           while (!(i === last));
        this.p4s_1.b5(lastRelatedPhaseIndex + 1 | 0, PhaseContent().h4s(phase, new (After())(reference)));
      }
      z4s(reference, phase) {
        if (hasPhase(this, phase))
          return Unit_instance;
        var index = findPhaseIndex(this, reference);
        if (index === -1) {
          throw new (InvalidPhaseException())('Phase ' + reference.toString() + ' was not registered for this pipeline');
        }
        this.p4s_1.b5(index, PhaseContent().h4s(phase, new (Before())(reference)));
      }
      a4t(phase, block) {
        var tmp0_elvis_lhs = findPhase(this, phase);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw new (InvalidPhaseException())('Phase ' + phase.toString() + ' was not registered for this pipeline');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var phaseContent = tmp;
        if (tryAddToPhaseFastPath(this, phase, block)) {
          this.q4s_1 = this.q4s_1 + 1 | 0;
          return Unit_instance;
        }
        phaseContent.j4s(block);
        this.q4s_1 = this.q4s_1 + 1 | 0;
        resetInterceptorsList(this);
        this.b4t();
      }
      b4t() {
      }
      toString() {
        return anyToString(this);
      }
    }
    initMetadataForClass($, 'Pipeline', VOID, VOID, VOID, [2]);
    PipelineClass = $;
  }
  return PipelineClass;
}
//region block: exports
export {
  Pipeline as Pipeline2vw6c5wpzxajt,
};
//endregion

//# sourceMappingURL=Pipeline.mjs.map
